/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';

/**
 * Represents a gift card applied to the cart, including its masked number, original balance, applied amount, and remaining balance.
 * @export
 * @interface SAPGiftCard
 */
export interface SAPGiftCard {
    /**
     * Gift card identifier.
     * @type {string}
     * @memberof SAPGiftCard
     */
    id?: string;
    /**
     * Masked gift card number.
     * @type {string}
     * @memberof SAPGiftCard
     */
    maskedNumber?: string;
    /**
     * 
     * @type {Price}
     * @memberof SAPGiftCard
     */
    balance?: Price;
    /**
     * 
     * @type {Price}
     * @memberof SAPGiftCard
     */
    appliedAmount?: Price;
    /**
     * 
     * @type {Price}
     * @memberof SAPGiftCard
     */
    remainingBalance?: Price;
}

/**
 * Check if a given object implements the SAPGiftCard interface.
 */
export function instanceOfSAPGiftCard(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SAPGiftCardFromJSON(json: any): SAPGiftCard {
    return SAPGiftCardFromJSONTyped(json, false);
}

export function SAPGiftCardFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAPGiftCard {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'maskedNumber': !exists(json, 'maskedNumber') ? undefined : json['maskedNumber'],
        'balance': !exists(json, 'balance') ? undefined : PriceFromJSON(json['balance']),
        'appliedAmount': !exists(json, 'appliedAmount') ? undefined : PriceFromJSON(json['appliedAmount']),
        'remainingBalance': !exists(json, 'remainingBalance') ? undefined : PriceFromJSON(json['remainingBalance']),
    };
}

export function SAPGiftCardToJSON(value?: SAPGiftCard | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'maskedNumber': value.maskedNumber,
        'balance': PriceToJSON(value.balance),
        'appliedAmount': PriceToJSON(value.appliedAmount),
        'remainingBalance': PriceToJSON(value.remainingBalance),
    };
}

